export const ENABLED_REDUX_LOGGER = false;
export const ENABLED_NETWORK_LOGGER = false;
export const LANDING_URL = 'https://weststeincard.com/';
